<template>
    <div class="field dropdown" :class="{ 'required': required }">
        <div class="heading">
            <label>{{ label }}</label>
            <Tooltip v-if="tooltip" :text="tooltip" />
        </div>
        <div class="input">
            <v-select
                :value="value"
                :placeholder="placeholder"
                :options="options"
                v-bind="{
                    clearable: false,
                    searchable: false,
                    ...selectOptions
                }"
                @input="$emit('input', $event)"
            >
                <template v-slot:no-options="slotProps">
                    <slot name="vSelectNoOptions" v-bind="slotProps" />
                </template>
                <template v-slot:option="slotProps">
                    <slot name="vSelectOption" v-bind="slotProps" />
                </template>
            </v-select>
        </div>
        <p v-if="v && v.$error" class="error text--orange small semi">This field is required</p>
    </div>
</template>

<script>
import Tooltip from '@/components/Tooltip';

export default {
    components: {
        Tooltip
    },
    props: {
        required: {
            type: Boolean,
            default: false,
        },
        label: {
            type: String,
            required: true,
        },
        placeholder: {
            type: String,
            default: null,
        },
        tooltip: {
            type: String,
            default: null,
        },
        value: {
            type: [String, Object, Number],
            default: '',
        },
        options: {
            type: [Array, Promise],
            default: () => [],
        },
        selectOptions: {
            type: Object,
            default: () => {},
        },
        v: {
            type: Object,
            default: null,
        }
    },
};
</script>

<style lang="scss" scoped>
    .error {
        margin-top: 0.5em;
    }

    .heading {
        display: flex;
        align-items: center;
        justify-content: space-between;
    }

    ::v-deep .tool {
        margin-left: 0.5em;
        margin-right: 5px;
    }

    ::v-deep .tool-icon {
        width: 15px;
        height: 15px;
        font-size: 9px;
    }

    .v-select::v-deep {
        .vs__clear {
            display: block !important;
            fill: white;
        }
    }
</style>

